import { useState } from "react";
import { RelatorioFisicoFinanceiro } from "../../model/PrestacaoDeContas/RelatorioFisicoFinanceiro";
import Campo from "../Campo";
import styles from "./styles.module.css";
import CampoSelect from "../Campo/CampoSelect";
import CampoTextoLongo from "../Campo/CampoTextoLongo";
import {
  addList,
  editList,
  removeList,
} from "../../controllers/ListOperations";
import { PagamentoEfetuado } from "../../model/PrestacaoDeContas/RelacaoPagamentosEfetuados";

type Props = {
  refPagamento?: PagamentoEfetuado;
  closeModal: Function;
  list: PagamentoEfetuado[];
  setList: React.Dispatch<React.SetStateAction<PagamentoEfetuado[]>>;
  index?: number;
};

const ModalRelacaoPagamentos = ({
  refPagamento,
  closeModal,
  list,
  setList,
  index,
}: Props) => {
  const [recurso, setRecurso] = useState(refPagamento?.recurso || 1);
  const [nome, setNome] = useState(refPagamento?.nomeFavorecido || "");
  const [cnpjCpf, setCnpjCpf] = useState(refPagamento?.cnpjCpf || "");
  const [licitacao, setLicitacao] = useState(refPagamento?.licitacao || "NA");
  const [tipoDocumento, setTipoDoc] = useState(
    refPagamento?.documento.tipo || "NF"
  );
  const [numDocumento, setNumDoc] = useState(
    refPagamento?.documento.numero || ""
  );
  const [dataDocumento, setDataDoc] = useState(
    refPagamento?.documento.data || new Date(Date.now())
  );
  const [chobPagamento, setChobPag] = useState(
    refPagamento?.pagamento.CHOB || "ESPECIE"
  );
  const [dataPagamento, setDataPag] = useState(
    refPagamento?.pagamento.data || new Date(Date.now())
  );
  const [naturezaDespesa, setNaturezaDespesa] = useState(
    refPagamento?.naturezaDespesa || ""
  );
  const [valor, setValor] = useState(refPagamento?.valor || 0);

  return (
    <form className={styles.formModal}>
      <h2>Pagamento Efetuado</h2>
      <div className={styles.camposDados}>
        <div className={styles.gridCampos}>
          <Campo
            title="Recurso"
            type="number"
            maxLength={64}
            required={true}
            setter={setRecurso}
            value={recurso}
          />
          <CampoSelect
            title="Licitação"
            setter={setLicitacao}
            value={licitacao}
          >
            <option value={"NA"}>NA (Não se Aplica)</option>
            <option value={"SIM"}>SIM</option>
          </CampoSelect>
        </div>
        <div className={styles.gridCampos}>
          <Campo
            title="Nome do Favorecido"
            type="text"
            maxLength={64}
            required={true}
            setter={setNome}
            value={nome}
          />
          <Campo
            title="CNPJ/CPF Favorecido"
            type="text"
            maxLength={64}
            required={true}
            setter={setCnpjCpf}
            value={cnpjCpf}
          />
        </div>
        <h3 className={styles.subTitulo}>
          <strong>Documento</strong>
        </h3>
        <div className={styles.gridCampos}>
          <div className={styles.gridCampos}>
            <CampoSelect title="Tipo" setter={setTipoDoc} value={tipoDocumento}>
              <option value={"NF"}>NF (Nota Fiscal)</option>
              <option value={"RECIBO"}>RECIBO</option>
            </CampoSelect>
            <Campo
              title="Data"
              type="date"
              maxLength={64}
              required={true}
              setter={setDataDoc}
              value={dataDocumento}
            />
          </div>
          <Campo
            title="Numero"
            type="text"
            maxLength={64}
            required={true}
            setter={setNumDoc}
            value={numDocumento}
          />
        </div>
        <hr className={styles.separador} />
        <h3 className={styles.subTitulo}>
          <strong>PAGAMENTO</strong>
        </h3>
        <div className={styles.gridCampos}>
          <Campo
            title="CH/OB do Pagamento"
            type="text"
            maxLength={64}
            required={true}
            setter={setChobPag}
            value={chobPagamento}
          />
          <Campo
            title="Data do Pagamento"
            type="date"
            maxLength={64}
            required={true}
            setter={setDataPag}
            value={dataPagamento}
          />
        </div>
        <hr className={styles.separador} />
        <div className={styles.gridCampos}>
          <Campo
            title="Natureza de despeza"
            type="text"
            maxLength={64}
            required={true}
            setter={setNaturezaDespesa}
            value={naturezaDespesa}
          />
          <Campo
            title="Valor"
            type="number"
            maxLength={64}
            required={true}
            setter={setValor}
            value={valor}
          />
        </div>
      </div>

      {!refPagamento && (
        <input
          type="submit"
          value="+ Adicionar Relatório"
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            const item: PagamentoEfetuado = {
              recurso: recurso,
              nomeFavorecido: nome,
              cnpjCpf: cnpjCpf,
              licitacao: licitacao,
              documento: {
                tipo: tipoDocumento,
                numero: numDocumento,
                data: dataDocumento,
              },
              pagamento: {
                CHOB: chobPagamento,
                data: dataPagamento,
              },
              naturezaDespesa: naturezaDespesa,
              valor: valor,
            };

            addList({
              item,
              list,
              setList,
            });
            closeModal();
          }}
        />
      )}
      {refPagamento !== undefined && index !== undefined && (
        <div className={styles.gridCampos}>
          <input
            type="submit"
            value="Editar Relatório"
            className={styles.addBtn}
            onClick={(e) => {
              e.preventDefault();
              const item: PagamentoEfetuado = {
                recurso: recurso,
                nomeFavorecido: nome,
                cnpjCpf: cnpjCpf,
                licitacao: licitacao,
                documento: {
                  tipo: tipoDocumento,
                  numero: numDocumento,
                  data: dataDocumento,
                },
                pagamento: {
                  CHOB: chobPagamento,
                  data: dataPagamento,
                },
                naturezaDespesa: naturezaDespesa,
                valor: valor,
              };
              editList({
                item,
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
          <input
            type="submit"
            value="Remover Meta"
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              removeList({
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
        </div>
      )}
    </form>
  );
};

export default ModalRelacaoPagamentos;
